import { useState } from "react";
import { BLOOD_PANEL_TESTS, INITIAL_QUESTIONNAIRE } from "./constants";

export function useQuestionnaireState() {
  const [questionnaire, setQuestionnaire] = useState(INITIAL_QUESTIONNAIRE);
  const [testValues, setTestValues] = useState({});

  const updateQuestionnaire = (key, value) => {
    if (key === "thiamazole" && value === "yes") {
      setQuestionnaire(prev => ({ ...prev, [key]: value, propylthiouracil: "no", propylthiouracilDosage: "" }));
    } else if (key === "propylthiouracil" && value === "yes") {
      setQuestionnaire(prev => ({ ...prev, [key]: value, thiamazole: "no", thiamazoleDosage: "" }));
    } else {
      setQuestionnaire(prev => ({ ...prev, [key]: value }));
    }
  };

  const takesInterferingMeds = () => {
    return questionnaire.takesCalcium === "yes" || 
           questionnaire.takesIron === "yes" || 
           questionnaire.takesAcidReducer === "yes";
  };

  const isQuestionnaireComplete = () => {
    const required = ['age', 'gender', 'thyroidDiseasesBefore', 'levothyroxin', 'thiamazole', 'propylthiouracil', 'cordarone', 'iodinatedSalt', 'iodineSkin', 'iodineSpray', 'ctContrast'];
    const allRequiredFilled = required.every(key => questionnaire[key] !== "");
    
    const age = parseInt(questionnaire.age);
    if (questionnaire.gender === "female" && age >= 15 && age <= 48) {
      if (questionnaire.pregnant === "") return false;
    }
    
    if (questionnaire.thyroidDiseasesBefore === "yes") {
      if (questionnaire.graves === "" || questionnaire.hashimoto === "" || 
          questionnaire.thyroidNodules === "" || questionnaire.thyroidCancer === "" ||
          questionnaire.totalThyroidectomy === "" || questionnaire.partialThyroidectomy === "") {
        return false;
      }
    }
    
    if (questionnaire.levothyroxin === "yes") {
      if (questionnaire.levoBeforeBreakfast === "" || 
          questionnaire.levoRegularly === "" ||
          questionnaire.takesCalcium === "" ||
          questionnaire.takesIron === "" ||
          questionnaire.takesAcidReducer === "") {
        return false;
      }
      if (takesInterferingMeds() && questionnaire.levoTwoHoursApart === "") return false;
    }
    
    return allRequiredFilled;
  };

  const handleInputChange = (key, value) => {
    const filteredValue = value.replace(/[^0-9.,]/g, '');
    const normalizedValue = filteredValue.replace(',', '.');
    if (normalizedValue === "" || normalizedValue === "." || /^[0-9]*\.?[0-9]*$/.test(normalizedValue)) {
      setTestValues(prev => ({ ...prev, [key]: normalizedValue }));
    }
  };

  const hasAnyValue = Object.values(testValues).some(v => v !== "" && v !== undefined);
  
  const isBloodPanelRequired = questionnaire.thiamazole === "yes" || questionnaire.propylthiouracil === "yes";
  
  const isBloodPanelComplete = () => {
    if (!isBloodPanelRequired) return true;
    return BLOOD_PANEL_TESTS.every(test => testValues[test.key] && testValues[test.key] !== "");
  };

  const hasAcuteSymptoms = () => {
    return questionnaire.hasFever === "yes" || 
           questionnaire.hasFatigue === "yes" || 
           questionnaire.hasNeckPain === "yes" || 
           questionnaire.symptomsAfterVirusInfection === "yes";
  };

  return {
    questionnaire,
    setQuestionnaire,
    updateQuestionnaire,
    testValues,
    setTestValues,
    handleInputChange,
    takesInterferingMeds,
    isQuestionnaireComplete,
    hasAnyValue,
    isBloodPanelRequired,
    isBloodPanelComplete,
    hasAcuteSymptoms,
  };
}
